<template>
  <v-tabs v-model="selectedTab" class="tabs-flex" color="primary">
    <v-tab v-for="{ value, text } in tabs" :key="value" class="flex-grow-1" :value="value" slim>{{ text }}</v-tab>
  </v-tabs>
</template>

<script setup lang="ts">
import { useVModel } from '@vueuse/core'

import type { BufferTab } from '@/types/RightContainer'

const props = defineProps<{
  modelValue: string
  tabs: BufferTab[]
}>()

const emits = defineEmits<{ (e: 'update:modelValue', v: string): void }>()

const selectedTab = useVModel(props, 'modelValue', emits)
</script>
<style lang="scss" scoped>
.tabs-flex {
  flex: 0 0 auto;
}
</style>
